"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POWER_SEQUENCE_LABEL_RE = void 0;
exports.collapseEdges = collapseEdges;
exports.deriveVariant = deriveVariant;
const KIND_RANK = { rail: 3, bus: 2, control: 1, analog: 1 };
exports.POWER_SEQUENCE_LABEL_RE = /PG|power.?good|seq|\bEN\b|enable|CHRG|BOOST|CAM_ON|rst|reset/i;
const MERGED_LABEL_CAP = 52;
const EDGE_LABEL_CAP = 26;
function sanitize(s) {
    return s.replace(/"/g, "'").replace(/&/g, '+').replace(/</g, '(').replace(/>/g, ')');
}
function mergeLabels(labels) {
    const seen = new Set();
    const out = [];
    for (const raw of labels) {
        const l = sanitize(raw);
        if (l && !seen.has(l)) {
            seen.add(l);
            out.push(l);
        }
    }
    let s = out.join(' · ');
    if (s.length > MERGED_LABEL_CAP) {
        const kept = [];
        let total = 0;
        for (const l of out) {
            if (total + l.length > MERGED_LABEL_CAP && kept.length > 0) {
                kept.push(`+${out.length - kept.length} more`);
                break;
            }
            kept.push(l);
            total += l.length;
        }
        s = kept.join(' · ');
    }
    return s;
}
function collapseEdges(edges) {
    const pairs = new Map();
    for (const e of edges) {
        const [a, b] = e.from <= e.to ? [e.from, e.to] : [e.to, e.from];
        const key = `${a} ${b}`;
        let entry = pairs.get(key);
        if (!entry) {
            entry = { a, b, acc: { labels: [], dirs: new Map(), nets: new Set() } };
            pairs.set(key, entry);
        }
        const kind = e.kind;
        entry.acc.labels.push({ rank: KIND_RANK[kind] ?? 0, label: e.label ?? '' });
        let d = entry.acc.dirs.get(kind);
        if (!d) {
            d = [false, false];
            entry.acc.dirs.set(kind, d);
        }
        if (e.directed ?? true) {
            d[e.from === a ? 0 : 1] = true;
        }
        for (const net of e.nets ?? []) {
            entry.acc.nets.add(net);
        }
    }
    const out = [];
    for (const { a, b, acc } of pairs.values()) {
        let kind = 'bus';
        let bestRank = -1;
        for (const k of acc.dirs.keys()) {
            const rank = KIND_RANK[k] ?? 0;
            if (rank > bestRank) {
                bestRank = rank;
                kind = k;
            }
        }
        const [fwd, back] = acc.dirs.get(kind) ?? [false, false];
        const labels = [...acc.labels].sort((x, y) => y.rank - x.rank).map((t) => t.label);
        out.push({ a, b, kind, label: mergeLabels(labels), fwd, back, nets: [...acc.nets] });
    }
    return out;
}
function trimLabel(edge) {
    if (edge.label.length > EDGE_LABEL_CAP) {
        return { ...edge, label: edge.label.slice(0, EDGE_LABEL_CAP - 2) + '…' };
    }
    return edge;
}
function deriveVariant(doc, variant) {
    const kindById = new Map(doc.blocks.map((b) => [b.id, b.kind]));
    const rendered = doc.edges.filter((e) => e.render !== false);
    let filtered;
    switch (variant) {
        case 'full':
            filtered = rendered;
            break;
        case 'power':
            filtered = rendered.filter((e) => e.kind === 'rail' ||
                ((e.kind === 'control' || e.kind === 'analog') &&
                    exports.POWER_SEQUENCE_LABEL_RE.test(e.label ?? '') &&
                    (kindById.get(e.from) === 'power' || kindById.get(e.to) === 'power')));
            break;
        case 'signal':
            filtered = rendered.filter((e) => e.kind !== 'rail');
            break;
    }
    return collapseEdges(filtered).map(trimLabel);
}
//# sourceMappingURL=derive-variant.js.map